import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Fab, Card, InputAdornment, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import SearchData from "../components/SearchData";
import api from "../../../components/services/api";
import useDebounce from "../../../libs/hooks/useDebounce";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  // textField: {
  //   marginLeft: theme.spacing(1),
  //   marginRight: theme.spacing(1),
  //   width: 100,
  // },
  // dense: {
  //   marginTop: theme.spacing(2),
  // },
  menu: {
    width: 100,
  },
}));

export default function Vehicle() {
  const classes = useStyles();
  const MenuActive = useSelector((state) => state.MenuActive.List);
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
const [key,setKey] =useState('')
  
  const debouncedKey = useDebounce(key, 500);
  /* table data */
  const columns = [
    { field: "GroupName", headerName: "Group", width: 200 },
    { field: "VehicleName", headerName: "Name Vehicle", width: 200 },
    { field: "VehicleNo", headerName: "Vehicle NO.", width: 200 },
    {
      field: "Status",
      headerName: "Status",
      width: 250,
      valueFormatter: ({ value }) =>
        value === true ? "ACTIVE" : "INACTIVE",
    },
    {
      field: "Action",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        const onClickEdit = async () => {
          let id = params.id;
          console.log(id);
        };
        return (
          <>
            <Link
              to={{
                pathname: `/Setting/EditVehicle/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                Edit
              </Button>
            </Link>
          </>
        );
      },
    },
  ];

  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };

  const fetchContainerList = async () => {
    try {
      const result = await api.get(`api/vehicle/list?keyword=${debouncedKey}`);
      setData(result.data);
      setDataFilter(result.data);
      console.log(result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  useEffect(() => {
    fetchContainerList();
  }, [debouncedKey]);

  return (
    <div>
      <Card
        variant="outlined"
        style={{ padding: "20px", margin: "25px", height: "86vh" }}
      >
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ยานพาหนะ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Vehicle
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Vehicle
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          sx={{ justifyContent: "end" }}
          style={{ marginTop: "10px" }}
          alignItems="center"
        >
           <TextField
           InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            disableUnderline: true,
          }}
          label="Search"
          onChange={e => setKey(e.target.value)}
          size="small"
        />
        </Grid>

        <Box
          sx={{
            height: 650,
            width: "100%",
            marginTop: "10px",
            "& .Active": {
              color: "#28A745",
            },
            "& .Inactive": {
              color: "#F53C56",
            },
          }}
        >
          <DataGrid
            getRowId={(r) => r.VehicleId}
            rows={dataFilter}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
            getCellClassName={(params) => {
              if (params.field === "Status") {
                return params.value === true ? "Active" : "Inactive";
              }
            }}
          />
        </Box>
      </Card>
      {MenuActive.find((x) => x.ActionNo === "A071") && (
        <Link to="/Setting/AddVehicle">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
      )}
    </div>
  );
}
